export const ALERTS = {
  TITLE: 'Alertas',
  SEARCH_PLACEHOLDER: 'Buscar alertas...',
  NO_ALERTS_FOUND: 'No se encontraron alertas',
  STATUS: {
    OPEN: 'Abiertas',
    CLOSED: 'Cerradas',
  },
  FILTERS: {
    HOSTNAME: 'Hostname',
    FILTER_BY_HOSTNAME: 'Filtrar por Hostname',
    CLUSTER: 'Clúster',
    FILTER_BY_CLUSTER: 'Filtrar por Clúster',
    ALERT_DATE: 'Fecha de Alerta',
  },
  MONITORING: {
    LABEL: 'Monitoreando',
    HOST_SINGULAR: 'host',
    HOST_PLURAL: 'hosts',
    GROUP_SINGULAR: 'grupo',
    GROUP_PLURAL: 'grupos',
    EVENT_SINGULAR: 'evento',
    EVENT_PLURAL: 'eventos',
    DASHBOARDS: 'Dashboards',
    SECURITY: 'Seguridad',
    STATISTICS: 'Estadísticas',
    AGENTS: 'Agentes',
    DOWNLOAD_AGENT: 'Descargar Agente',
  },
  DRAWER: {
    CLOSE_ALERT: 'Cerrar Alerta',
    DOWNLOAD_RUNBOOK: 'Descargar runbook',
    CLOSURE_REASON: 'Razón de Cierre',
    IS_THERE_AFFECTED_DATA: '¿Hay datos afectados?',
    USER_NOTES: 'Notas del Usuario',
    FIELDS: {
      HOST: 'Host',
      GROUP: 'Grupo',
      OCCURRENCES: 'Ocurrencias',
      LAST_DETECTED: 'Última Detección',
      ADDITIONAL_DETAILS: 'Detalles Adicionales',
      RAW_LOG: 'Log Sin Procesar',
    },
    EVENT: 'Evento',
    EVENTS: 'Eventos',
  },
  ESCALATION_DIALOG: {
    TITLE: 'Escalar Alerta',
    DESCRIPTION: 'Estás a punto de escalar la siguiente alerta:',
    WARNING: 'Esta alerta será remitida para revisión inmediata.',
    SUCCESS: (alertName: string) => `Alerta "${alertName}" escalada exitosamente`,
    ACTIONS: {
      CANCEL: 'Cancelar',
      CONFIRM: 'Confirmar Escalamiento',
    },
  },
  CLOSURE_DIALOG: {
    TITLE: 'Cerrar Alerta',
    FIELDS: {
      REASONS_LABEL: 'Razón de cierre',
      NOTES_LABEL: 'Notas Adicionales',
      AFFECTED_DATA_LABEL: '¿Hay datos afectados?',
    },
    REASONS: {
      THREAT_MITIGATED: 'Amenaza Mitigada',
      ISSUE_RESOLVED: 'Problema Resuelto',
      NO_ACTION_REQUIRED: 'No se Requiere Acción',
      DUPLICATE_ALERT: 'Alerta Duplicada',
      SYSTEM_UPDATED: 'Sistema Actualizado/Parcheado',
      USER_EDUCATED: 'Usuario Capacitado',
    },
    ACTIONS: {
      CANCEL: 'Cancelar',
      CONFIRM: 'Cerrar Alerta',
    },
  },
  MESSAGES: {
    CLOSE_SUCCESS: 'Alerta cerrada exitosamente',
    UPDATE_ERROR: 'Error al actualizar la alerta',
  },
}
